import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import { Badge as AntBadge } from 'antd';
import React, { forwardRef } from 'react';
import styled from 'styled-components';
var StyledBadge = styled(AntBadge).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['bgColor', 'textColor'].includes(prop);
  }
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  .ant-badge-count {\n    background-color: ", ";\n    color: ", ";\n  }\n"])), function (props) {
  return props.bgColor && props.theme.colors[props.bgColor];
}, function (props) {
  return props.textColor && props.theme.colors[props.textColor];
});
var Badge = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement("div", {
    ref: ref
  }, /*#__PURE__*/React.createElement(StyledBadge, props));
});
export default Badge;